module.exports = __webpack_public_path__ + "img/mailchannels.dbe85e83.png";